import { render } from "./SubFeature.vue?vue&type=template&id=b82d8cf8"
import script from "./SubFeature.vue?vue&type=script&lang=js"
export * from "./SubFeature.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__